import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import * as moment from "jalali-moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { InvStatusKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { InvVoucherKind } from "src/app/backoffice/inv/models/inv-voucher-kind.model";
import { InvVoucherDetail } from "../../models/inv-voucher-detail.model";
import { InvVoucherHeader } from "../../models/inv-voucher-header.model";
import { Warehouse } from "../../models/warehouse.model";
@Component({
  selector: "inv-voucher-header-import-excel-form",
  templateUrl: "./inv-voucher-header-import-excel-form.component.html",
  styleUrls: ["./inv-voucher-header-import-excel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvVoucherHeaderImportExcelFormComponent extends BaseFormComponent<InvVoucherHeader> {
  isloading: boolean = false;
  gridInfo: GridColumnInfoDetail[];
  VoucherState: string;
  WarehouseList: Warehouse[];
  InvVoucherKindList: InvVoucherKind[];
  public hColumns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    let BranchId = this.accountService.authService.currentBranchId;
    this.apiName = "InvVoucherHeader";
    this.label = "دریافت فایل اکسل";
    super.ngOnInit();
    await this.setInvVoucherKind();
    await this.setWarehouse();
    await this.setData();
  }
  async setColumns() {
    await super.setColumns();
    this.hColumns = [];
    this.hColumns.push(<form_control>{
      label: "ردیف اول عنون ستونهاست.",
      controlType: FormControlTypes.checkbox,
      modelName: "isFirstRowColumnsName",
      disabled: false,
      name: "isFirstRowColumnsName",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.hColumns = this.hColumns;
  }
  async setData() {
    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear) {
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      this.model.Year = this.accountService.authService.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        this.model.FiscalYearId = x.Id;
        this.model.Year = x.Year;
      });
    }
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("INV", "StatusKind", InvStatusKind.Registered)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
        });
    }
  }
  addControl(): void {
    this.setValue("isFirstRowColumnsName", true);
  }
  async onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length > 1) {
      alert("انتخاب بیش از یک فایل مجاز نیست.");
      return;
    } else {
      const result = await this.parseExcelDoc(target.files[0]).catch((err) => console.error(err));
      this.SetInvVoucherHeaderInfo(result);
    }
  }
  getDate(newValue: any) {
    var _dateValue = moment.from(newValue, "fa", "YYYY/MM/DD HH:mm:ss").format("YYYY/MM/DD HH:mm:ss") as any;
    return new Date(_dateValue);
  }
  SetInvVoucherHeaderInfo(excelData: any[]) {
    let ColumnsName = [];
    let VoucherNo = 0;
    let VoucherKindCode = 0;
    let VoucherHeader: InvVoucherHeader = <InvVoucherHeader>{};
    VoucherHeader.InvVoucherDetailList = [];
    let VoucherDetail: InvVoucherDetail = <InvVoucherDetail>{};
    let ErroeMessage: string = "";
    if (this.formGroup.get("isFirstRowColumnsName")?.value === true) {
      ColumnsName = excelData[0] as any[];
    } else ColumnsName = this.gridInfo.filter((c) => c.name != null && c.title != "عملیات" && !c.hidden) as any[];
    let isFirtsRow: boolean = true;
    for (var i = 0; i < excelData.length; i++) {
      var x = excelData[i];
      let index: number = 0;
      if (this.formGroup.get("isFirstRowColumnsName").value === true && isFirtsRow === true) {
      } else {
        VoucherDetail = <InvVoucherDetail>{};
        ColumnsName.forEach(async (c) => {
          let key: string;
          if (c.name) key = c.name;
          else {
            if (this.gridInfo.some((g) => g.title === c || g.name == c)) {
              key = this.gridInfo.find((g) => g.title === c || g.name == c).name;
            }
          }
          if (key.trim() === "VoucherNo" && VoucherNo !== Number(x[index])) {
            if (!ErroeMessage && VoucherHeader.InvVoucherDetailList.length > 0) {
              this.saveVoucher(VoucherHeader);
            }
            VoucherHeader = <InvVoucherHeader>{};
            VoucherHeader.InvVoucherDetailList = [];
            VoucherHeader.BranchId = this.accountService.authService.currentBranchId;
            VoucherHeader.VoucherKindId = this.model.VoucherKindId;
            VoucherHeader.WarehouseId = this.model.WarehouseId;
            VoucherHeader.StatusKindId = this.model.StatusKindId;
            VoucherHeader.FiscalYearId = this.model.FiscalYearId;
            VoucherHeader.VoucherNo = 0;
            VoucherHeader.TotalPrice = 0;
            VoucherHeader.DetailLedgerCode;
          }

          if (key.trim() === "VoucherKindCode") {
            VoucherHeader[key.trim()] = x[index];
            VoucherHeader.VoucherKindId = this.InvVoucherKindList.find((gg) => gg.Code === VoucherHeader.VoucherKindCode)?.Id;
            VoucherKindCode = VoucherHeader.VoucherKindCode;
            if (!VoucherHeader.VoucherKindId) {
              (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} نوع سند ' ${VoucherHeader.SubLedgerCode} پیدا نشد.`), "دریافت سند " + ",";
            }
          }
          if (key.trim() === "WarehouseCode") {
            VoucherHeader[key.trim()] = x[index];
            VoucherHeader.WarehouseId = this.WarehouseList.find((gg) => gg.Code === VoucherHeader.WarehouseCode)?.Id;
            if (!VoucherHeader.WarehouseId) {
              (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} انبار ' ${VoucherHeader.WarehouseCode} پیدا نشد.`), "دریافت سند " + ",";
            }
          }
          if (
            key.trim() === "VoucherNo" ||
            key.trim() === "ShamsiVoucherDate" ||
            key.trim() === "BranchCode" ||
            key.trim() === "HeaderComment" ||
            key.trim() === "DetailLedgerCode"
          ) {
            VoucherHeader[key.trim()] = x[index];
            if (key.trim() === "ShamsiVoucherDate") VoucherHeader.VoucherDate = this.getDate(VoucherHeader.ShamsiVoucherDate);
            VoucherNo = VoucherHeader.VoucherNo;
          } else {
            VoucherDetail[key.trim()] = x[index];
            VoucherDetail.InvVoucherHeaderId = 0;
          }

          index++;
        });
        this.VoucherState = `در حال ذخیره سند شماره ${VoucherHeader.VoucherNo} تاریخ ${VoucherHeader.ShamsiVoucherDate}`;
        this.cd.markForCheck();
        if (!VoucherHeader.InvVoucherDetailList.some((g) => g.RowNumber === VoucherDetail.RowNumber)) {
          VoucherHeader.InvVoucherDetailList.push(VoucherDetail);
        } else {
          console.log(VoucherHeader);
        }
      }
      if (isFirtsRow === true) isFirtsRow = false;
      if (ErroeMessage) break;
    }
    if (!ErroeMessage && VoucherHeader.InvVoucherDetailList.length > 0) {
      this.saveVoucher(VoucherHeader);
    } else this.sts.showDialog(ErroeMessage, "خطا در دریافت کالا");
  }
  public cancel() {
    this.close();
  }
  saveVoucher(entity) {
    this.VoucherState = `در حال ذخیره سند شماره ${entity.VoucherNo} تاریخ ${entity.ShamsiVoucherDate}`;
    this.cd.markForCheck();
    entity.VoucherNo = 0;
    entity.FixNo = 0;
    entity.DailyNo = 0;
    this.httpCommonService
      .create(this.apiName, entity)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (row) => {
          this.cd.markForCheck();
        },
        (error) => this.sts.showDialog(`خطای ذخیره تغییرات: ${Utilities.getHttpResponseMessage(error)}`, "پیغام خطا")
      );
  }
  async setInvVoucherKind() {
    await this.httpCommonService
      .get("InvVoucherKind/GetActiveVoucherKind")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data: InvVoucherKind[]) => {
          if (data) {
            this.InvVoucherKindList = data as InvVoucherKind[];
          }
        },
        (error) => {}
      );
  }
  async setWarehouse() {
    await this.httpCommonService
      .get("Warehouse")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data: Warehouse[]) => {
          if (data) {
            this.WarehouseList = data as Warehouse[];
          }
        },
        (error) => {}
      );
  }
}
